var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 14.25C8.75 13.8358 9.08579 13.5 9.5 13.5H15.5C15.9142 13.5 16.25 13.8358 16.25 14.25C16.25 14.6642 15.9142 15 15.5 15H9.5C9.08579 15 8.75 14.6642 8.75 14.25Z",
    fill: "#cda742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 11.25C8.75 10.8358 9.08579 10.5 9.5 10.5H15.5C15.9142 10.5 16.25 10.8358 16.25 11.25C16.25 11.6642 15.9142 12 15.5 12H9.5C9.08579 12 8.75 11.6642 8.75 11.25Z",
    fill: "#cda742"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68934 3.43934C4.97064 3.15804 5.35217 3 5.75 3H9.5C9.91421 3 10.25 3.33579 10.25 3.75C10.25 4.16421 9.91421 4.5 9.5 4.5L5.75 4.5L5.75 20.25H19.25L19.25 4.5L15.5 4.5C15.0858 4.5 14.75 4.16421 14.75 3.75C14.75 3.33579 15.0858 3 15.5 3H19.25C19.6478 3 20.0294 3.15804 20.3107 3.43934C20.592 3.72065 20.75 4.10218 20.75 4.5V20.25C20.75 20.6478 20.592 21.0294 20.3107 21.3107C20.0294 21.592 19.6478 21.75 19.25 21.75H5.75C5.35218 21.75 4.97065 21.592 4.68934 21.3107C4.40804 21.0294 4.25 20.6478 4.25 20.25V4.5C4.25 4.10217 4.40804 3.72064 4.68934 3.43934Z",
    fill: "#cda742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C11.7044 3 10.9413 3.31607 10.3787 3.87868C9.81607 4.44129 9.5 5.20435 9.5 6H15.5C15.5 5.20435 15.1839 4.44129 14.6213 3.87868C14.0587 3.31607 13.2956 3 12.5 3ZM9.31802 2.81802C10.1619 1.97411 11.3065 1.5 12.5 1.5C13.6935 1.5 14.8381 1.97411 15.682 2.81802C16.5259 3.66193 17 4.80653 17 6V6.75C17 7.16421 16.6642 7.5 16.25 7.5H8.75C8.33579 7.5 8 7.16421 8 6.75V6C8 4.80653 8.47411 3.66193 9.31802 2.81802Z",
    fill: "#cda742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/Terms.2969b075b41d8fc456562c0b861b1ddd.svg";
export { ForwardRef as ReactComponent };